// components/RecurrentesDrawer.tsx
import React, { useState, useEffect } from 'react';
import { fetchRecurrentesActivas } from '../../services/General/recurrenteService';
import { Recurrente } from '../../types/recurrente';

interface RecurrentesDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectRecurrente: (recurrente: Recurrente) => void;
}

const RecurrentesDrawer: React.FC<RecurrentesDrawerProps> = ({ isOpen, onClose, onSelectRecurrente }) => {
  const [recurrentes, setRecurrentes] = useState<Recurrente[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [activeOnly, setActiveOnly] = useState(true);
  const [notExpired, setNotExpired] = useState(true);

  useEffect(() => {
    if (isOpen) {
      loadRecurrentes();
    }
  }, [isOpen, search]);

  const loadRecurrentes = async () => {
    setLoading(true);
    setActiveOnly(true);
    setNotExpired(true);
    try {
      const data = await fetchRecurrentesActivas(search, activeOnly, notExpired);
      setRecurrentes(data);
    } catch (error) {
      console.error('Error cargando recurrentes:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Backdrop con fade de Bootstrap */}
      <div 
        className={`offcanvas-backdrop fade ${isOpen ? 'show' : ''}`} 
        onClick={onClose}
        style={{ display: isOpen ? 'block' : 'none' }}
      ></div>

      {/* Drawer usando offcanvas de Bootstrap */}
      <div 
        className={`offcanvas offcanvas-start ${isOpen ? 'show' : ''}`}
        tabIndex={-1}
        style={{ width: '85%', maxWidth: '350px' }}
      >
        <div className="offcanvas-header bg-primary text-white">
          <h5 className="offcanvas-title">
            <i className="fas fa-repeat me-2"></i>
            Visitas Recurrentes
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
        </div>
        <div className="offcanvas-body p-3">
          <div className="mb-3">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por nombre o cédula..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              // disabled={recurrentes.length === 0} 
            />
          </div>

          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <span className="text-muted">Cargando...</span>
            </div>
          ) : recurrentes.length === 0 ? (
            <div className="text-center py-4 text-muted">
              <i className="bi bi-person-x fs-1 d-block mb-2"></i>
              <p>No hay visitas recurrentes activas</p>
            </div>
          ) : (
            <div className="list-group">
              {recurrentes.map((r) => (
                <div key={r.id} className="list-group-item list-group-item-action p-3">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h6 className="mb-0">{r.guest_name}</h6>
                      <small className="text-muted">
                        <i className="bi bi-person-badge me-1"></i>
                        {r.guest_cedula}
                      </small>
                    </div>
                    <span className="badge bg-info">{r.visitas_realizadas}/{r.max_visitas_sin_cita}</span>
                  </div>
                  
                  {r.motivo && (
                    <p className="small text-muted mb-2">
                      <i className="bi bi-chat-text me-1"></i>
                      {r.motivo}
                    </p>
                  )}
                  
                  <div className="d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                      <i className="bi bi-envelope me-1"></i>
                      {r.host_email.split('@')[0]}
                    </small>
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => onSelectRecurrente(r)}
                    >
                      <i className="bi bi-box-arrow-in-right me-1"></i>
                      Ingreso
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RecurrentesDrawer;